import { LinkIcon, MapPinIcon, CalendarDaysIcon, BellAlertIcon } from "@heroicons/react/24/outline";
import PageWrapper from "../component/sharedComponents/PageWrapper";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
    DocumentTextIcon,
    BookmarkIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import avatar from "../assets/images/Avatar.avif"
import { getMyProfile } from "../slices/1-auth/2-myProfile/thunk";
import ReviewsSection from "../component/profile/ReviewsSection";
import PostsBase from "../component/sharedComponents/PostsBase";
import { getMyBookmarks } from "../slices/4-bookmark/thunk";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ar";
import "dayjs/locale/en";
import { useSearchParams } from "react-router-dom";
dayjs.extend(relativeTime);
const ProfilePage = () => {
    const { i18n, t } = useTranslation();
    const { profile } = useSelector((state) => state.myProfile);
    const { bookmarks } = useSelector((state) => state.bookmark);
    const [searchParams] = useSearchParams();
    const initialTab = searchParams.get("tab") || "posts";
    const [activeTab, setActiveTab] = useState(initialTab);
    const locale = i18n.language === "ar" ? "ar" : "en";
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getMyProfile());
        dispatch(getMyBookmarks({}));
    }, [dispatch]);

    useEffect(() => {
        setActiveTab(initialTab);
    }, [initialTab]);

    const profileTabs = [
        { name: "posts", icon: DocumentTextIcon },
        // { name: "reviews", icon: StarIcon },
        { name: "saved", icon: BookmarkIcon },
        { name: "notification", icon: BellAlertIcon },
    ];

    const formatJoinedDate = (isoDate, locale = "en") => {
        if (!isoDate) return "";
        const date = new Date(isoDate);
        return new Intl.DateTimeFormat(locale, { month: "long", year: "numeric" }).format(date);
    };

    // console.log(profile)
    return (
        <PageWrapper>
            <div className="overflow-hidden ">

                {/* COVER */}
                <div className="relative w-full h-52">
                    {profile?.coverImage ?
                        <img
                            src={profile?.coverImage}
                            className="object-cover w-full h-full"
                            alt="cover"
                        />
                        : <div className="w-full h-44 dark:bg-bg-dark-tertiary bg-bg-light-tertiary lg:h-52">
                        </div>
                    }

                    {/* AVATAR */}
                    <img
                        src={profile?.avatar || avatar}
                        alt="avatar"
                        className="absolute border-2 rounded-full h-28 w-28 lg:h-32 lg:w-32 lg:-bottom-16 -bottom-8 start-4 border-primary-light dark:border-primary"
                    />
                </div>

                {/* PROFILE INFO */}
                <div className="flex flex-col gap-6 px-4 pt-10 lg:pt-20 md:flex-row md:justify-between">

                    {/* LEFT INFO */}
                    <div>
                        <h1 className="text-2xl font-bold text-black dark:text-white">
                            {profile?.fullName}
                        </h1>
                        <p className="text-sm text-text-muted-light dark:text-text-muted-dark">
                            @{profile?.code}
                        </p>

                        {/* BIO */}
                        <p className="max-w-xl mt-3 text-sm text-gray-700 dark:text-gray-300">
                            {profile?.bio}
                        </p>

                        {/* META */}
                        <div className="flex flex-wrap gap-5 mt-4 text-sm text-text-muted-light dark:text-text-muted-dark">

                            {profile?.location && (
                                <div className="flex items-center gap-1">
                                    <MapPinIcon className="w-4 h-4" />
                                    <span>{profile?.location}</span>
                                </div>
                            )}

                            {profile?.website && (
                                <div className="flex items-center gap-1 dark:text-primary text-primary-light">
                                    <LinkIcon className="w-4 h-4" />
                                    <a href="/#" className="hover:underline">
                                        {profile?.website}
                                    </a>
                                </div>
                            )}

                            <div className="flex items-center gap-1">
                                <CalendarDaysIcon className="w-4 h-4" />
                                {t("profile.joined")} {formatJoinedDate(profile?.createdAt, i18n.language)}
                            </div>
                        </div>

                        {/* FOLLOW */}
                        {(profile?.following || profile?.followers) &&
                            <div className="flex gap-6 mt-4">
                                <div>
                                    <span className="font-semibold text-black dark:text-white">
                                        {profile?.following}
                                    </span>{" "}
                                    <span className="text-text-muted-light dark:text-text-muted-dark">{t("profile.following")}</span>
                                </div>
                                <div>
                                    <span className="font-semibold text-black dark:text-white">
                                        {profile?.followers}
                                    </span>{" "}
                                    <span className="text-text-muted-light dark:text-text-muted-dark">{t("profile.followers")}</span>
                                </div>
                            </div>
                        }
                    </div>

                    {/* RIGHT BUTTON */}
                    <div className="flex items-start">

                        <button
                            onClick={() => navigate("/profile/edit")}
                            className="px-5 py-2 text-sm transition-colors border rounded-xl border-border-light dark:border-border-dark hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary"
                        >
                            {t("profile.edit")}
                        </button>
                    </div>
                </div>

                {/* TABS */}
                <div className="w-full mt-8 border-b border-border-light dark:border-border-dark">
                    <div className="flex justify-between w-full ">
                        {profileTabs?.map(tab => {
                            const Icon = tab.icon;
                            const active = activeTab === tab.name;

                            return (
                                <button
                                    key={tab.name}
                                    onClick={() => setActiveTab(tab.name)}
                                    className={`
          py-4 lg:text-sm text-sm font-medium relative w-1/3
          flex items-center justify-center gap-1
          transition-colors
          ${active
                                            ? "dark:text-white text-black"
                                            : "text-text-muted-light dark:text-text-muted-dark hover:text-black dark:hover:text-white"}
        `}
                                >
                                    <Icon className="w-3 h-3 lg:h-5 lg:w-5" />
                                    <span>{t(`profile.tabs.${tab.name}`)}</span>

                                    {active && (
                                        <span className="absolute bottom-0 left-0 w-full h-0.5 dark:bg-primary bg-primary-light rounded-full" />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* TAB CONTENT */}
                <div className="p-6">
                    {activeTab === "posts" && <PostsBase posts={profile?.Posts} />}
                    {activeTab === "reviews" && (
                        <ReviewsSection
                            // reviews={profile?.reviews}
                            reviews={profile?.Comments}

                            onSubmit={(data) => {
                                // console.log("New Review:", data);
                            }}
                        />
                    )}
                    {activeTab === "saved" && <PostsBase posts={bookmarks} />}
                    {
                        activeTab === "notification" &&
                        <div className="flex flex-col gap-4">
                            {!profile?.Notifications || profile?.Notifications?.length === 0 ?
                                <div className="flex flex-col items-center justify-center max-w-2xl mx-auto space-y-4 text-center text-gray-300">
                                    <div className="w-full px-4 py-6 space-y-4 overflow-hidden text-center duration-300 border bg-bg-light-secondary border-border-light rounded-xl dark:bg-bg-dark-secondary dark:border-border-dark">
                                        {/* <BookmarkIcon className="w-16 h-16 text-[#80B39D] mx-auto" /> */}
                                        <h2 className="text-xl font-semibold text-black dark:text-white">
                                            {t("notifications.noNotifications")}
                                        </h2>
                                        <p className="text-gray-400">
                                            {t("notifications.description")}
                                        </p>
                                    </div>
                                </div>
                                :
                                profile?.Notifications?.map((item) => (
                                    <div
                                        className="overflow-hidden duration-300 border bg-bg-light-secondary border-border-light rounded-xl hover:shadow-glow dark:bg-bg-dark-secondary dark:border-border-dark"
                                    >
                                        <a
                                            href={item?.action_url}
                                            key={item?.id}
                                            className={`flex items-start gap-3 px-4 py-3 transition-colors cursor-pointer ${!item?.isRead
                                                ? "hover:bg-bg-light-primary dark:hover:bg-bg-dark-primary bg-[#00FF9D0D]"
                                                : "hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary"
                                                }`}
                                        >
                                            <img
                                                src={item?.image_url}
                                                alt="avatar"
                                                className="w-10 h-10 rounded-full"
                                            />

                                            <div className="flex-1">
                                                <div className="text-sm text-black dark:text-white">
                                                    <p className="font-semibold">
                                                        {locale === "ar" ? item?.title_AR : item?.title_EN}
                                                    </p>
                                                    <p className="text-text-muted-light dark:text-text-muted-dark">
                                                        {locale === "ar"
                                                            ? item?.message_AR
                                                            : item?.message_EN}
                                                    </p>
                                                </div>

                                                <p className="mt-1 text-xs text-text-muted-light">
                                                    {dayjs(item?.createdAt).locale(locale).fromNow()}
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                        </div>
                    }
                </div>
            </div>
            {/* <EditProfileModal
                isOpen={isEditOpen}
                onClose={() => setIsEditOpen(false)}
                initialData={profile}
            /> */}

        </PageWrapper>
    );
};

export default ProfilePage;
